export default {

    // general slider settings
    slideReordering: false,

    // loop
    loop: true,

    // autoplay
    autoplay: false,
    autoplaySpeed: 3000,

    dots: true,
    dotsPosition: 'bottom',
    dotAccentColor: '#1c8ff3',

    arrows: true,
    arrowBg: '#1c8ff3',
    arrowColor: '#fff',
    arrowBgHover: '#fff',
    arrowColorHover: '#1c8ff3',
    arrowSize: 30,
    arrowRadius: 4,
    minHeight: 200,

    partialSlider: false,
    useSpacing: false,
    spaceBetween: 15,


    // slide individual settings
    slides: [
        {
            slideId: 'content-slide-'+Math.random().toString(36).substr(2, 16),
            childBackground: '#f1f1f1',
            horizontalPad: 50,
            verticalPad: 50,

            borderGeneralColor: '#cccccc',
            borderGeneralStyle: 'solid',
            borderGeneralWidth: 0,

            useIndividualBorder: false,

            borderTopColor: '#cccccc',
            borderTopStyle: 'solid',
            borderTopWidth: 1,
            
            borderRightColor: '#cccccc',
            borderRightStyle: 'solid',
            borderRightWidth: 1,
            
            borderBottomColor: '#cccccc',
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            
            borderLeftColor: '#cccccc',
            borderLeftStyle: 'solid',
            borderLeftWidth: 1,

            useIndividualBorderRadius: false,

            borderRadiusGeneral: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,

            backgroundColorChild: true,
            backgroundImageChild: false,
            backgroundImageChildSet: 'https://appjustable.com/weebly/app_in_process/dummy-content/preview-dummy-image-app.jpg',

            xAxisPosition: 'center',
            yAxisPosition: 'center',

            slideAnimation: false,
            animationClass: 'bundle-slide-animation-slideInTop'
        },
        {
            slideId: 'content-slide-'+Math.random().toString(36).substr(2, 16),
            childBackground: '#f1f1f1',
            horizontalPad: 50,
            verticalPad: 50,

            borderGeneralColor: '#cccccc',
            borderGeneralStyle: 'solid',
            borderGeneralWidth: 0,

            useIndividualBorder: false,

            borderTopColor: '#cccccc',
            borderTopStyle: 'solid',
            borderTopWidth: 1,
            
            borderRightColor: '#cccccc',
            borderRightStyle: 'solid',
            borderRightWidth: 1,
            
            borderBottomColor: '#cccccc',
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            
            borderLeftColor: '#cccccc',
            borderLeftStyle: 'solid',
            borderLeftWidth: 1,

            useIndividualBorderRadius: false,

            borderRadiusGeneral: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,

            backgroundColorChild: true,
            backgroundImageChild: false,
            backgroundImageChildSet: 'https://appjustable.com/weebly/app_in_process/dummy-content/preview-dummy-image-app.jpg',

            xAxisPosition: 'center',
            yAxisPosition: 'center',
            slideAnimation: false,
            animationClass: 'bundle-slide-animation-slideInTop'
        },
        {
            slideId: 'content-slide-'+Math.random().toString(36).substr(2, 16),
            childBackground: '#f1f1f1',
            horizontalPad: 50,
            verticalPad: 50,

            borderGeneralColor: '#cccccc',
            borderGeneralStyle: 'solid',
            borderGeneralWidth: 0,

            useIndividualBorder: false,

            borderTopColor: '#cccccc',
            borderTopStyle: 'solid',
            borderTopWidth: 1,
            
            borderRightColor: '#cccccc',
            borderRightStyle: 'solid',
            borderRightWidth: 1,
            
            borderBottomColor: '#cccccc',
            borderBottomStyle: 'solid',
            borderBottomWidth: 1,
            
            borderLeftColor: '#cccccc',
            borderLeftStyle: 'solid',
            borderLeftWidth: 1,

            useIndividualBorderRadius: false,

            borderRadiusGeneral: 0,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,

            backgroundColorChild: true,
            backgroundImageChild: false,
            backgroundImageChildSet: 'https://appjustable.com/weebly/app_in_process/dummy-content/preview-dummy-image-app.jpg',

            xAxisPosition: 'center',
            yAxisPosition: 'center',
            slideAnimation: false,
            animationClass: 'bundle-slide-animation-slideInTop'
        },
    ]

}


// WEBPACK FOOTER //
// ./src/store/elementSettings/contentslidersettings.js